import React from 'react'
import Grid from '@mui/material/Grid'
import SelectButton from './SelectButton'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FastfoodIcon from '@mui/icons-material/Fastfood';
import MicrowaveIcon from '@mui/icons-material/Microwave';

type Prop = {
  iconType?: 'microwave' | 'food',
  title?: string,
  values: number[],
  unit: string,
  onSelect: (value: number) => void,
  drawer: boolean,
  onClose: () => void,
}

type State = {
  drawer: boolean,
}

class SelectButtonTemplate extends React.Component<Prop, State> {
  constructor(props: Prop) {
    super(props)
    this.state = {
      drawer: this.props.drawer,
    }
    this.onSelectButtonClick = this.onSelectButtonClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
  }

  render() {
    // 値ごとのボタンを生成
    const buttons = this.props.values.map((value: number) =>
      <Grid xs={6} item key={value}>
        <SelectButton value={value} unit={this.props.unit} onClick={this.onSelectButtonClick} />
      </Grid>)

    return (
      <SwipeableDrawer
        anchor={'bottom'}
        open={this.state.drawer}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        disableSwipeToOpen
        swipeAreaWidth={16}
        disableBackdropTransition={false}
        disableDiscovery={false}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: "column",
            gap: 1,
          }}
          role="presentation"
        >
          <Box
            onClick={this.handleClose}
            sx={{
              width: '100%',
              height: 24,
              mx: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              ":hover": {
                bgcolor: 'grey.100',
              },
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 6,
                bgcolor: 'grey.400',
                borderRadius: 3,
              }}
            />
          </Box>
          <Grid
            container
            // padding={1}
            spacing={1}
            pb={3}
            sx={{
              px: 1,
            }}
          >
            {this._title()}
            {buttons}
          </Grid>
        </Box>
      </SwipeableDrawer>
    )
  }

  _title() {
    if (!this.props.title) {
      return null
    }
    let RenderIcon
    let IconStyle: React.CSSProperties = {}

    switch (this.props.iconType) {
      case 'microwave':
        RenderIcon = MicrowaveIcon
        IconStyle = { position: 'relative', top: '7px' }
        break

      case 'food':
        RenderIcon = FastfoodIcon
        IconStyle = { position: 'relative', top: '7px' }
        break

      default:
        // props.iconType が何も該当しない場合のデフォルト
        RenderIcon = MicrowaveIcon
        IconStyle = {}
        break
    }

    return (
      <Grid item xs={12}>
        <Typography variant="subtitle2" mt={0.5}>
          <RenderIcon style={IconStyle} />
          {this.props.title}
        </Typography>
      </Grid>
    )
  }

  onSelectButtonClick(value: number) {
    this.props.onSelect(value)
  }

  handleClose() {
    this.setState({ drawer: false })
    this.props.onClose()
  }

  handleOpen() {
    this.setState({ drawer: true })
  }

  componentDidUpdate(prevProps: Readonly<Prop>) {
    if (prevProps.drawer !== this.props.drawer) {
      this.setState({ drawer: this.props.drawer });
    }
  }
}

export default SelectButtonTemplate
